import React from "react";
import { GenericResponse } from "../CreateRound/CreateRoundModels";
import ItemSelect from "./ItemSelect";
import { ListResponse } from "../api/ApiNgModels";
import { RoundOverviewItem } from "../RoundOverview/RoundOverviewModels";
import RoundOverviewUtil from "../RoundOverview/RoundOverviewUtil";

interface RoundSelectProps {
    from?: Date;
    to?: Date;
    value: number;
    disabled?: boolean;
    filter?: (item: RoundOverviewItem) => boolean;
    onChange: (item: RoundOverviewItem | undefined) => void;
    allItemEnabled: boolean;
    helperText?: string;
    error?: boolean;
    refreshEnabled?: boolean;
    style?: React.CSSProperties;    
}
const RoundSelect: React.FC<RoundSelectProps> = (props) => {
      
    const getItems = async (pageSize: number, lastId?: number) : Promise<GenericResponse<ListResponse<RoundOverviewItem>>> => {
        return await RoundOverviewUtil.getRoundOverviews(props.from, props.to, pageSize, lastId);
    };


    const getId = (item?: RoundOverviewItem) : number => {
        return item ? item.id : 0;
    };
    const getName = (item?: RoundOverviewItem) : string => {
        return item ? RoundOverviewUtil.getRoundTitle(item) : "";
    };

    const onChange = (item?: RoundOverviewItem) : void => {
        if (props.onChange) {
            props.onChange(item);
        }
    };
   const sortCompare = (x: RoundOverviewItem, y: RoundOverviewItem) : number => {
        var comp = x.roundTypeName.localeCompare(y.roundTypeName);
        if (comp !== 0) {
            return comp;
        }
        var xDeadline = x.deadline ? new Date(x.deadline) : new Date(0);
        var yDeadline = y.deadline ? new Date(y.deadline) : new Date(0);
        comp = xDeadline.getTime() - yDeadline.getTime();
        if (comp !== 0) {
            return comp;
        }
        return x.id - y.id;
    };
   
    return (
        <ItemSelect<RoundOverviewItem, number>
            value={props.value}
            label="Round"
            getId={getId}
            getIdString={it => getId(it).toLocaleString()}
            getName={getName}
            getItems={getItems}
            idFromString={s => s ? parseInt(s) : 0}
            onChange={onChange}
            disabled={props.disabled}
            filter={props.filter}
            getInfoText={it => it ? `Id: ${it.id} | Title:  ${getName(it)}` : ""}
            allItemEnabled={props.allItemEnabled}
            helperText={props.helperText}
            error={props.error}
            refreshEnabled={props.refreshEnabled}
            style={props.style}
            sortCompare={sortCompare}
    />
    );
};

export default RoundSelect;
